/**
 * FE-034 — the cookie consent decision. Hydrated from localStorage on the
 * client; the banner shows until a choice is made.
 */

import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import {
  isFairAnalyticsAllowed,
  readFairCookieConsent,
  writeFairCookieConsent,
  type FairCookieConsentChoice,
  type FairCookieConsentRecord,
} from '../fair-cookie-consent.data'

export const useFairCookieConsent = defineStore('fairCookieConsent', () => {
  const hydrated = ref(false)
  const record = ref<FairCookieConsentRecord | null>(null)

  const decided = computed(() => record.value !== null)
  /** Never during SSG; on the client only until a decision is stored. */
  const bannerVisible = computed(() => hydrated.value && !decided.value)
  const analyticsAllowed = computed(() => isFairAnalyticsAllowed(record.value))

  function hydrate() {
    record.value = readFairCookieConsent()
    hydrated.value = true
  }

  function decide(choice: FairCookieConsentChoice) {
    record.value = writeFairCookieConsent(choice)
  }

  const acceptAll = () => decide('accepted')
  const rejectNonEssential = () => decide('essential')

  return { hydrated, record, decided, bannerVisible, analyticsAllowed, hydrate, decide, acceptAll, rejectNonEssential }
})
